<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：首页 > 评分记录</div>
      <!--      <div class="curse-btn" @click="to(`/formsub`)">添加项目</div>-->
      <div class="curse-btn" @click="$router.go(-1)">返回</div>
    </div>
    <div class="list-content">
      <!--      <div class="search-box">-->
      <!--        <div class="search-item">-->
      <!--          <el-input v-model="keyword" placeholder="机构名称"></el-input>-->
      <!--        </div>-->
      <!--        <div class="search-item">-->
      <!--          <el-button type="primary" icon="el-icon-refresh" @click="searchreset">重置</el-button>-->
      <!--          <el-button type="primary" icon="el-icon-search" @click="searchFun">搜索</el-button>-->
      <!--        </div>-->
      <!--      </div>-->
      <el-table
        :data="list"
        border
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="100">
        </el-table-column>
        <el-table-column prop="admin_name" label="专家名称"> </el-table-column>
        <!--                <el-table-column-->
        <!--                    prop="admin_name"-->
        <!--                    label="状态">-->
        <!--                </el-table-column>-->
        <el-table-column prop="score" label="评分"> </el-table-column>
        <el-table-column prop="update_time" label="评分时间">
          <template slot-scope="scope">
            {{ scope.row.update_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="approve_time" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="showItem(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!--      <div class="page-box flex justify-center padding-top-sm">-->
      <!--        <el-pagination-->
      <!--          class="page-all margin-bottom"-->
      <!--          background-->
      <!--          @current-change="init"-->
      <!--          :current-page.sync="page"-->
      <!--          :page-size="limit"-->
      <!--          layout="prev, pager, next"-->
      <!--          :total="total"-->
      <!--        >-->
      <!--        </el-pagination>-->
      <!--      </div>-->
    </div>
    <apply-level1-dialog
      :dialog="applyLevel1Dialog"
      :id="id"
      :rid="rid"
      @watchState="watchState"
    ></apply-level1-dialog>
    <apply-level2-dialog
      :dialog="applyLevel2Dialog"
      :id="id"
      :rid="rid"
      @watchState="watchState"
    ></apply-level2-dialog>
  </div>
</template>
<script>
import { getProjectScoreList } from "@/api/admin";
import ApplyLevel1Dialog from "@/views/adminhome/common/ApplyLevel1Dialog";
import ApplyLevel2Dialog from "@/views/adminhome/common/ApplyLevel2Dialog";
import { zhDate } from "@/tools";

export default {
  name: "index",
  data() {
    return {
      id: "",
      rid: "",
      type: "",
      list: [],
      applyLevel1Dialog: false,
      applyLevel2Dialog: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.admintoken;
    },
  },
  components: { ApplyLevel2Dialog, ApplyLevel1Dialog },
  created() {
    this.$emit("setActive", {
      active: 1,
    });
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.init();
  },
  methods: {
    // 获取列表
    async init() {
      let _data = await getProjectScoreList(this.id, this.type);
      if (_data.code === 200) {
        this.list = _data.data;
      } else {
        this.$message.error(_data.message);
      }
    },
    showItem(row) {
      this.rid = row.id;
      if (this.type == 1) {
        this.applyLevel1Dialog = true;
      } else {
        this.applyLevel2Dialog = true;
      }
    },
    watchState() {
      this.applyLevel1Dialog = false;
      this.applyLevel2Dialog = false;
    },
  },
  watch: {},
  filters: {
    formatDate(val) {
      return zhDate(val * 1000, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;

  .curse-content {
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .search-box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .search-item {
        width: 33.3%;
        padding-right: 20px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
